import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Armchair, Truck, ArrowRight } from 'lucide-react';
import { SERVICES } from '../data/content';

const iconMap: Record<string, React.ElementType> = {
  'Carpet': Layers,
  'Sofa': Armchair,
  'Truck': Truck,
};

const Services = () => {
  return (
    <section id="usluge" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-lg text-primary-orange font-bold tracking-wider uppercase mb-3">Naše Usluge</h2>
          <h3 className="text-5xl md:text-6xl font-bold text-neutral-darkNavy">Premium pranje tepiha</h3>
          <div className="w-24 h-1 bg-primary-blue mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {SERVICES.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group border border-gray-100"
              >
                <div className="w-16 h-16 bg-primary-blue/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary-orange group-hover:text-white transition-colors duration-300">
                  <Icon size={32} className="text-primary-blue group-hover:text-white transition-colors" />
                </div>
                
                <h4 className="text-3xl font-bold text-neutral-darkNavy mb-4">{service.title}</h4>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                <a href="#kontakt" className="inline-flex items-center text-lg text-primary-orange font-semibold group-hover:translate-x-2 transition-transform">
                  Saznajte više <ArrowRight size={16} className="ml-2" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
